
import { defineComponent } from 'vue';
import { SHOW_BRAND } from '@/utils';

export default defineComponent({
  name: 'HomeFooter',
  data() {
    return {
      SHOW_BRAND,
    };
  },
});
